import React from "react";

import { Button, LinkButton } from "../../../shared/ui/button/button";

import "./AppErrorFallback.css";

const DETAIL_MAX_LENGTH = 320;

function formatDetailValue(value) {
  const text = String(value || "").trim();
  if (!text) return "";
  if (text.length <= DETAIL_MAX_LENGTH) return text;
  return `${text.slice(0, DETAIL_MAX_LENGTH - 3)}...`;
}

function RefreshIcon() {
  return (
    <svg
      aria-hidden="true"
      className="app-error-fallback__button-icon"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 12a8 8 0 1 1-2.343-5.657M20 4v6h-6"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    </svg>
  );
}

export default function AppErrorFallback({
  errorMessage,
  errorPath,
  isLoggedIn,
}) {
  const path = formatDetailValue(
    errorPath || globalThis.location?.pathname || "/",
  );
  const homeHref = isLoggedIn ? "/dashboard" : "/";
  const homeLabel = isLoggedIn ? "Go to dashboard" : "Go to home";
  const detailError = formatDetailValue(errorMessage);

  return (
    <main className="app-error-fallback" role="alert" aria-live="assertive">
      <div className="app-error-fallback__inner">
        <div className="app-error-fallback__heading">
          <span className="app-error-fallback__status">
            Something went wrong
          </span>

          <h1 className="app-error-fallback__title">We hit a snag.</h1>

          <p className="app-error-fallback__body">
            Your work is safe. We've been notified and are already looking into
            it.
          </p>
        </div>

        <div className="app-error-fallback__actions">
          <LinkButton
            className="app-error-fallback__action app-error-fallback__action--home"
            href={homeHref}
            size="lg"
            variant="secondary"
          >
            {homeLabel}
          </LinkButton>

          <Button
            className="app-error-fallback__action app-error-fallback__action--reload"
            leftIcon={<RefreshIcon />}
            size="lg"
            variant="pillPrimary"
            onClick={() => globalThis.location.reload()}
          >
            Reload page
          </Button>
        </div>

        <div className="app-error-fallback__detail">
          <div className="app-error-fallback__detail-item">
            <span className="app-error-fallback__detail-label">Path</span>
            <span className="app-error-fallback__detail-value">{path}</span>
          </div>
          {detailError ? (
            <div className="app-error-fallback__detail-item">
              <span className="app-error-fallback__detail-label">Error</span>
              <span className="app-error-fallback__detail-value">
                {detailError}
              </span>
            </div>
          ) : null}
        </div>
      </div>
    </main>
  );
}
